
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import LeadChecklist from '@/components/LeadChecklist.vue';
import { Checklist, Lead } from '@/types';

@Component({
  components: {
    LeadChecklist,
  },
})
export default class LeadChecklists extends Vue {
  @Prop(Boolean) readonly loading!: boolean

  panels: number[] = []

  get lead(): Lead {
    return this.$store.getters.currentLead;
  }

  get checklists(): Checklist[] {
    return this.lead && Array.isArray(this.lead.checklists) && this.lead.checklists.length > 0
      ? this.lead.checklists
      : [];
  }
}
